<template>
    <div>
        这个是完成页面
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>

</style>